import { useEffect, useState } from 'react';

/** Tiny hash router: #/today, #/week?date=2026-10-21 … (works with any static host). */
export interface Route {
  path: string;
  params: URLSearchParams;
}

function parse(): Route {
  const raw = window.location.hash.replace(/^#/, '') || '/today';
  const [path, query = ''] = raw.split('?');
  return { path: path || '/today', params: new URLSearchParams(query) };
}

export function useRoute(): Route {
  const [route, setRoute] = useState(parse);
  useEffect(() => {
    const on = () => setRoute(parse());
    window.addEventListener('hashchange', on);
    return () => window.removeEventListener('hashchange', on);
  }, []);
  return route;
}

export function navigate(path: string, params?: Record<string, string | null | undefined>) {
  const q = new URLSearchParams();
  for (const [k, v] of Object.entries(params ?? {})) if (v != null) q.set(k, v);
  const s = q.toString();
  window.location.hash = `${path}${s ? `?${s}` : ''}`;
}

/** Update query params without adding a history entry. */
export function setParams(params: Record<string, string | null | undefined>) {
  const { path, params: cur } = parse();
  for (const [k, v] of Object.entries(params)) {
    if (v == null) cur.delete(k);
    else cur.set(k, v);
  }
  const s = cur.toString();
  history.replaceState(null, '', `#${path}${s ? `?${s}` : ''}`);
  window.dispatchEvent(new HashChangeEvent('hashchange'));
}
